import { useState, useCallback, useRef } from "react";
import { getData } from "../../../../services/library";
import { logEventos } from "../../../../services/services";

export const usePedidosFacturados = () => {
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const abortControllerRef = useRef(null);

  const obtenerPedidos = useCallback(async (desde, hasta) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    
    abortControllerRef.current = new AbortController();
    setLoading(true);
    setError(null);
    
    try {
      const sucAuth = localStorage.getItem("suc_auth")?.split(",") || [];
      const url = `/envasado_pedidos/facturacionsucauth/${desde} 00:00:00/${hasta} 23:59:59/${sucAuth.join(",")}`;
      
      const data = await new Promise((resolve, reject) => {
        getData(url, (result) => {
          if (result && Array.isArray(result)) {
            resolve(result);
          } else {
            resolve([]);
          }
        }, abortControllerRef.current.signal);
      });
      
      setPedidos(data);
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error("Error:", err);
        setError("Error al cargar los pedidos");
      }
    } finally {
      setLoading(false);
    }
  }, []);

  // Solo log de acceso, sin fetch automático
  useState(() => {
    logEventos("acceso al menú Facturados", "Envasado", "Pedidos Facturados", localStorage.getItem("user"));
  }, []);

  const estadisticas = {
    totalFacturas: pedidos.length,
    facturadas: pedidos.filter(p => p.estado === 311 || p.estado === 312).length,
    anuladas: pedidos.filter(p => p.estado === 328).length
  };

  return {
    pedidos,
    loading,
    error,
    estadisticas,
    obtenerPedidos,
    setError
  };
};